import React from "react";
import { BottomNav, TopNav, MobileHeader } from "@/components/BottomNav";
import { FloatingCart } from "@/components/FloatingCart";

export function MobileShell({ children, showCart = true }) {
    return (
        <div className="w-full min-h-screen bg-background text-foreground">
            <TopNav />
            <MobileHeader />
            <div className="mx-auto w-full max-w-md md:max-w-6xl relative min-h-screen pb-28 md:pb-16 px-4 md:px-8 pt-4 md:pt-6">
                {children}
            </div>
            <footer className="px-4 md:px-8 pb-24 md:pb-8">
                <p className="mx-auto w-full max-w-md md:max-w-6xl text-center text-[11px] md:text-xs font-light tracking-[0.02em] text-muted-foreground/85 leading-relaxed">
                  © 2026 Dimpal's Collection | A Unit of Dimple Lifestyle Ventures
                </p>
            </footer>
            {showCart && <FloatingCart />}
            <BottomNav />
        </div>
    );
}
